import { captureException } from '@sentry/react';

export const logAndCaptureException = (error) => {
  console.error(error);
  captureException(error);
};
